/** The settings, as a page of its own reachable from every menu. */

import { MenuScreen } from './MenuScreen';
import { SettingsPanel, type SeedSetting } from './SettingsPanel';
import type { SettingsStore } from './SettingsStore';

export function createSettingsScreen(
  settings: SettingsStore,
  onClose: () => void,
  seed: SeedSetting,
): MenuScreen {
  const panel = new SettingsPanel(settings, seed);
  const screen = new MenuScreen(
    'ASETUKSET',
    'Seed kulkee sivun osoitteessa. Muut asetukset tallentuvat tähän selaimeen.',
    onClose,
    'VALMIS',
    () => {
      if (panel.applySeed()) onClose();
    },
  );
  screen.body.appendChild(panel.root);
  return screen;
}
